import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { PurchaseSearchProvider } from './context/purchase-search-context';
import { PurchaseSearchComponent } from './purchase-search-component';

export function PurchaseSearchFactory() {
    return (
        <BaseLayoutFactory>
            <PurchaseSearchProvider>
                <PurchaseSearchComponent />
            </PurchaseSearchProvider>
        </BaseLayoutFactory>
    );
}
